import type { AIMessage } from '../types';
import { callLLM } from './llmClient';

const TITLE_TAG_REGEX = /<title>([\s\S]*?)<\/title>/i;

export function extractTitleFromContent(content: string): { title: string | null; cleanContent: string } {
  const match = content.match(TITLE_TAG_REGEX);
  if (match) {
    const title = match[1].trim().slice(0, 30);
    const cleanContent = content.replace(/<title>[\s\S]*?<\/title>\s*/gi, '').trim();
    return { title: title || null, cleanContent };
  }
  return { title: null, cleanContent: content };
}

export function stripTitleTag(content: string): string {
  return content.replace(/<title>[\s\S]*?<\/title>\s*/gi, '').trim();
}

const TITLE_SYSTEM_PROMPT =
  '你是会话标题生成器。把用户指令概括为一个会话标题（10-20字）。' +
  '标题必须是对「指令本身做什么」的摘要，禁止描述指令中提到的作品、剧情或创作内容。' +
  '示例一：用户指令"帮我把第3章结尾改得更有悬念" → 输出：修改第3章结尾悬念\n' +
  '示例二：用户指令"请阅读前六章剧情并总结" → 输出：阅读并总结前六章剧情\n' +
  '只输出标题本身，不要引号、序号或解释。';

/** 规则化兜底标题：取用户指令的首段，归一化后截断 */
export function fallbackTitle(userMessage: string): string {
  const text = (userMessage || '').replace(/\s+/g, ' ').trim();
  if (!text) return '';
  const cleaned = text
    .replace(/^请|^帮我|^麻烦/g, '')
    .replace(/[，。！？、,!?.]$/g, '')
    .trim();
  const head = cleaned.split(/[，。！？、,!?.]/)[0]?.trim() || cleaned;
  return head.length > 20 ? head.slice(0, 20) : head;
}

export async function generateTitle(model: string, userMessage: string, provider?: string): Promise<string | null> {
  if (!model || !userMessage) return null;

  const text = userMessage.length > 500 ? userMessage.slice(0, 500) : userMessage;
  const messages: AIMessage[] = [
    { role: 'system', content: TITLE_SYSTEM_PROMPT },
    { role: 'user', content: text },
  ];

  try {
    const title = await callLLM(model, messages, 0.3, 30, undefined, provider);
    const clean = (title || '').replace(/["'「」《》]|^标题[:：]|^输出[:：]/g, '').trim();
    if (clean.length >= 6 && clean.length <= 30) {
      return clean;
    }
    if (clean.length > 30) {
      return clean.slice(0, 30);
    }
    // 模型输出异常（过短/含剧情式编造无法校验）→ 规则化兜底
    return fallbackTitle(userMessage) || null;
  } catch {
    return fallbackTitle(userMessage) || null;
  }
}
